export default __webpack_public_path__ + "static/horizon-f2d02cd6f88df71d528820db427fb87b.svg";